/* eslint-disable indent */

import getters from '@/store/modules/signage/getters'
import mutations from '@/store/modules/signage/mutations'
import state from '@/store/modules/signage/state'
import actions from '@/store/modules/signage/actions'

export default {
    namespaced: true,
    getters,
    mutations,
    state,
    actions
}
